import clsx from 'clsx';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';

import { Modal } from './Modal.jsx';
import { Button } from './Button.jsx';
import { t } from '../../lib/i18n.js';

export function ConfirmDialog({
  open,
  onCancel,
  onConfirm,
  title,
  description,
  confirmLabel = t('common.confirm'),
  cancelLabel = t('common.cancel'),
  destructive = false,
  loading = false
}) {
  const Icon = destructive ? AlertTriangle : CheckCircle2;
  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onCancel}
      dismissable={!loading}
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>{cancelLabel}</Button>
          <Button
            variant={destructive ? 'danger' : 'primary'}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex gap-3">
        <span
          className={clsx(
            'mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full',
            destructive ? 'bg-danger/10 text-danger' : 'bg-success/10 text-success'
          )}
        >
          <Icon className="h-4 w-4" strokeWidth={1.75} />
        </span>
        <div className="min-w-0 flex-1">
          {title && <h2 className="text-base font-semibold tracking-tight text-ink">{title}</h2>}
          {description && <p className={clsx('text-sm text-ink-muted', title && 'mt-1')}>{description}</p>}
        </div>
      </div>
    </Modal>
  );
}
